<template>
  <button type="button" class="cms-file-block" @click="handleDownload">
    <span class="cms-file-icon" aria-hidden="true">📄</span>
    <span class="cms-file-info">
      <strong class="cms-file-title">{{ block.title || '文件下载' }}</strong>
      <span class="cms-file-subtitle">{{ block.subtitle || '点击下载' }}</span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'FileBlock',
  props: {
    block: {
      type: Object,
      required: true
    }
  },
  inject: {
    front: {
      default: null
    }
  },
  methods: {
    extractFileUrl(content) {
      if (!content) {
        return ''
      }
      const hrefMatch = content.match(/href=["']([^"']+)["']/i)
      if (hrefMatch) {
        return hrefMatch[1]
      }
      const srcMatch = content.match(/src=["']([^"']+)["']/i)
      if (srcMatch) {
        return srcMatch[1]
      }
      const urlMatch = content.match(/https?:\/\/[^\s<"']+/i)
      if (urlMatch) {
        return urlMatch[0]
      }
      const trimmed = String(content).trim()
      if (trimmed && !/[<>]/.test(trimmed)) {
        return trimmed
      }
      return ''
    },
    resolveUrl(url) {
      if (this.front && typeof this.front.resolveFileUrl === 'function') {
        return this.front.resolveFileUrl(url)
      }
      return url
    },
    handleDownload() {
      const url = this.extractFileUrl(this.block.bodyContent)
      if (!url) {
        window.alert('文件地址未配置')
        return
      }
      if (this.front && typeof this.front.downloadSiteFile === 'function') {
        this.front.downloadSiteFile(url, this.block.title || 'download')
        return
      }
      window.open(this.resolveUrl(url), '_blank')
    }
  }
}
</script>

<style scoped>
.cms-file-block {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 16px 18px;
  border: 1px solid var(--border);
  border-radius: var(--front-radius);
  background: #fff;
  color: var(--text);
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s, background 0.2s;
}

.cms-file-block:hover {
  border-color: var(--gold);
  background: #fffdf8;
}

.cms-file-icon {
  flex-shrink: 0;
  font-size: 28px;
  line-height: 1;
}

.cms-file-info {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.cms-file-title {
  color: var(--primary);
  font-size: 16px;
  line-height: 1.4;
}

.cms-file-subtitle {
  color: var(--subtle);
  font-size: 13px;
}
</style>
